module.exports = __webpack_public_path__ + "static/media/BAP7.2098d388.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP7.png
 ** module id = 685
 ** module chunks = 0
 **/